











import { defineComponent, ref } from '@nuxtjs/composition-api'
/*import { useUiState } from '~/composables';*/

export default defineComponent({
    data() {
        return {
            videoPlayer: null
        }
    },
    props: {
        url: {
            type: String,
            required: true
        },
        rootClass: {
            type: String,
            default: ''
        },
        fallbackImage: {
            type: String
        },
        showControls: {
            type: Boolean,
            default: true
        },
        isAutoplay: {
            type: Boolean,
            default: true
        },
        width: {
            type: Number,
            default: 1366
        },
        height: {
            type: Number,
            default: 768
        }
    },
    setup(props) {
        const isSSR = ref(true);
        const url = props.url;
        // example url : https://players.brightcove.net/1231248584001/default_default/index.html?videoId=5589126453001
        const merchId = url.split('players.brightcove.net/')[1].split('/default_default')[0]
        const videoId = url.split('?videoId=')[1];
        const properties = {
            autoplay: props.isAutoplay,
            muted: true,
            loop: true,
            playsinline: props.isAutoplay,
            controls: !!props.showControls,
            ...(props.fallbackImage ? { poster: props.fallbackImage } : {})
        }
        return {
            merchId,
            videoId,
            properties,
            isSSR
        }
    },
    mounted() {
        this.isSSR = false;
        console.log('BrightcoveVideo mounted', this.url);
        // @ts-ignore
        if (!!window.videojs) {
            this.initVideoPlayer();
        } else {
            const merchId = this.merchId;
            const script = document.createElement('script');
            script.src = `https://players.brightcove.net/${merchId}/default_default/index.min.js`;
            script.async = true;
            script.onload = () => {
                this.initVideoPlayer();
            };
            document.body.appendChild(script);

        }
    },
    methods: {
        initVideoPlayer() {
            const videoPlayerEl = this.$refs.videoPlayer;
            const isAutoplay = this.isAutoplay;
            if (!videoPlayerEl) return;
            
            //@ts-ignore
            this.videoPlayer = window.videojs(videoPlayerEl, this.properties);
            
            this.videoPlayer.ready(() => {
                const player = this.videoPlayer;
                
                player.on('loadeddata', () => {
                    this.$emit('loaded')
                })
                player.on('play', () => {
                    this.$emit('onPlay');
                });
                player.on('pause', () => {
                    this.$emit('onPause');
                });

                if (isAutoplay) {
                    player.play && player.play()
                }
            });
        },
        
        play() {
            if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
                try {
                    // Se il video è già in uno stato di play, facciamo un reset
                    if (!this.videoPlayer.paused()) {
                        return;
                    }
                    
                    const playPromise = this.videoPlayer.play();
                    if (playPromise && playPromise.then) {
                        playPromise.then(() => {
                        }).catch(e => {
                            console.error('Error playing video (promise rejected):', e);
                            // Se fallisce, proviamo a fare un workaround
                            setTimeout(() => {
                                if (this.videoPlayer && this.videoPlayer.paused()) {
                                    this.videoPlayer.play();
                                }
                            }, 100);
                        });
                    }
                } catch (e) {
                    console.error('Error playing video:', e);
                }
            } else {
                console.warn('VideoPlayer not ready for play', this.videoPlayer);
            }
        },
        
        pause() {
            if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
                try {
                    this.videoPlayer.pause();
                } catch (e) {
                    console.error('Error pausing video:', e);
                }
            } else {
                console.warn('VideoPlayer not ready for pause', this.videoPlayer);
            }
        },
        
        onLoaded() {
            this.$emit('loaded-data')
        }
    }
})
